<template>
<div class="bg-gray-3 p-t-md p-b-md">
  {{/** 案件及价格 */}}
  <div class="p-a-lg bg-white inner-content po-r">
    <div class="pull-right">应付金额: <span class="text-price">¥<span class="big-price">{{cas.reservePrice/100 || ''}}</span></span></div>
    <div class="pay-header">案例：{{cas.title}}</div>
  </div>
  {{/** 支付 */}}
  <div class="bg-white paying-wrp p-a-lg inner-content m-t-md">
    <div>
      <span :class="{'pay-icon': true, active: activePayment === 2}"
        @click="activePayment = 2"><img src="../assets/weixin.png"><span>微信支付</span></span>
      <span :class="{'pay-icon': true, active: activePayment === 1}"
        @click="activePayment = 1"><img src="../assets/zhifubao.png"><span>支付宝支付</span></span>
    </div>
    <div class="pay-amount m-b-lg">应付金额: <span class="text-price">¥<span class="big-price">{{cas.reservePrice/100 || ''}}</span></span></div>
    <div class="pay-btn-wrp">
      <button class="c-b c-b-pay m-r-lg" :disabled="!agreed" @click="pay">去付款</button>
      <span class="text-primary" role="button" @click="goBack">取消</span>
    </div>
    <div class="m-t-md gray-5 pay-agree">
      <label><input type="checkbox" v-model="agreed"> 我已阅读并同意《****》协议</label>
    </div>
  </div>
  <div v-if="loading" class="loading-mod"></div>
  <vue-loading v-if="loading" style="z-index: 20000; position: fixed; top: 40%; left: 47%; opacity: 1;" type="spiningDubbles" color="#000000" :size="{ width: '50px', height: '50px' }"></vue-loading>
  <div v-if="loading" style="position: fixed; top: 53%; left: 46%;">支付跳转中</div>
</div>
</template>
<script>
import toastr from 'mini-toastr';
import vueLoading from 'vue-loading-template';
import pingpp from 'pingpp-js';
import service from '../service/apiHelper';

export default {
  name: 'Pay',
  created() {
    // get the case by id
    service.getCaseInfo(this.$route.params.id).then((resp) => {
      this.cas = resp.data.case_info;
    }, (resp) => {
      toastr.error(resp, '加载案件错误');
    });
  },
  data() {
    return {
      activePayment: 1,
      agreed: false,
      cas: {},
      shop: {},
      loading: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    pay() {
      this.agreed = false;
      this.loading = true;
      service.pay({
        case_id: this.cas.id,
        shop_id: this.cas.shopInfo.id,
        quantity: 1,
        pay_method: this.activePayment,
      }).then((resp) => {
        // toastr.success('提交成功');
        // we need to send charge object to pingxx
        // console.log(resp.data);
        const charge = JSON.parse(resp.data.order_info.orderPay.extraPayInfo);
        // 微信支付需要跳转到新页面
        if (this.activePayment === 2) {
          // save the order_info
          const orderInfo = resp.data.order_info;
          // save this information
          localStorage.setItem('WEIXIN_ORDER_INFO', JSON.stringify(orderInfo));
          this.$router.push({ name: 'WeixinPay' });
          return;
        }
        pingpp.createPayment(charge, (result, err) => {
          if (result === 'success') {
            // 只有微信公众账号 wx_pub 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
            toastr.success('交易成功');
          } else if (result === 'fail') {
            // charge 不正确或者微信公众账号支付失败时会在此处返回
            toastr.error(err, '交易失败');
          } else if (result === 'cancel') {
            // 微信公众账号支付取消支付
            toastr.warn(err, '交易被取消');
          }
        });
      }, (resp) => {
        toastr.error(resp, '提交订单出错');
      });
    },
  },
  components: {
    vueLoading,
  },
};
</script>
<style>
.pay-header {
  font-size: 24px;
  font-weight: 600;
}
.text-price {
  color: #df3a4e;
}
.big-price {
  font-size: 24px;
}
.paying-wrp {
  border-top: 10px solid #c1c1c1;
}
.pay-icon {
  padding: 12px 20px;
  border: solid 1px transparent;
  margin-right: 50px;
  cursor: pointer;
}
.pay-icon.active {
  border: solid 1px #c1c1c1;
}
.pay-amount {
  margin-top: 130px;
}
.pay-icon img {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  margin-right: 1em;
}
.pay-icon span {
  vertical-align: middle;
}
.c-b.c-b-pay {
  border-radius: 4px;
	background-color: #ba882a;
  color: #ffffff;
  font-size: 14px;
	font-weight: 600;
  padding: 10px 50px;
  width: auto;
  height: auto;
}
/*.c-b.c-b-pay:hover {*/
  /*background-color: #e1e1e1;*/
  /*color: #787878;*/
/*}*/
.c-b.c-b-pay:disabled {
  background-color: #e1e1e1;
  color: #ffffff;
}
.text-primary {
  color: #ba882a;
}
.pay-agree {
  font-size: 12px;
	font-weight: 300;
}
.loading-mod {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 900px;
  background-color: #787878;
  z-index: 10000;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// Pay.vue?7126ed18